import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, take } from 'rxjs/operators';

import { GetAndSetAllFeatureToggles } from '../store/actions/feature/feature.actions';
import { State } from '../store/reducers';
import { selectFeatureTogglesLoaded } from '../store/selectors/feature/feature.selectors';

@Injectable({
  providedIn: 'root',
})
export class FeatureToggleInitializerService {
  constructor(private store: Store<State>) {}

  initialize(): () => Observable<boolean> {
    return () => {
      // Dispatch the action to load feature toggles
      this.store.dispatch(GetAndSetAllFeatureToggles());

      // Return observable that completes when feature toggles are loaded
      return this.store.select(selectFeatureTogglesLoaded).pipe(
        filter((loaded) => loaded === true),
        take(1),
      );
    };
  }
}
